import {z} from '@hono/zod-openapi';

const supplierPartSchema = z
  .object({
    supplierOrderable: z.boolean().nullable().default(null),
    oemCode: z.string().min(1),
    manufacturer: z.string().uuid(),
    supplier: z.string().uuid(),
    name: z.string(),
    currency: z.literal('CZK'),
    purchasePrice: z.number().finite().nonnegative().nullish(),
    recommendedSellingPrice: z.number().finite().nonnegative().nullish(),
    priceListCode: z.enum(['HONDA_CZ', 'NISSAN_CZ']),
    manufacturerNumberNormalized: z.string(),
    measurementUnit: z.string().nullish(),
    discountGroup: z.string().nullish(),
    supplierAccountCode: z.string().nullish(),
    supplierOrderTypeCode: z.string().nullish(),
  })
  .openapi('SupplierPart');
export const supplierPartsSearchResponseSchema = z
  .object({
    parts: z.array(supplierPartSchema),
    hasMore: z.boolean(),
  })
  .openapi('SupplierPartsSearchResponse');
export type SupplierPart = z.infer<typeof supplierPartSchema>;
export type SupplierPartsSearchResponse = z.infer<typeof supplierPartsSearchResponseSchema>;
